const regx = {
  phone: /^[0-9().\-/]+$/,
  phoneChars: /[.\-()]/g,
} as const;

export default regx;